import { createStyles, Grid, makeStyles, Typography } from "@material-ui/core"
import { Add as AddIcon } from '@material-ui/icons'
import React, { useEffect, useRef, useState } from "react"
import { useTranslation } from 'react-i18next'
import { useAuth } from "../../hooks/auth"
import { ShedSearch } from "../../interfaces/Shed"
import ShedApi from "../../services/ShedApi"
import ButtonUI from "../ui/ButtonUI"
import Select from "./Select"

const useStyles = makeStyles(() =>
    createStyles({
        root: {
          color: '#597DDA',
          marginLeft: '15px',
          marginTop: '5px',
          fontSize: '1rem',
        },
    })
);

type Props = any;

const SelectShedMovementType: React.FC<Props> = ({inputRef=null, userName, title, nameSelectShed, nameSelectMovementType, control, setValue, showConfirmButton, onChangeMovementType, onButtonClick, focusOnSelect, shedType}) => {
  const [shedList, setShedList] = useState<any>([]);
  const [movementTypeList, setMovementTypeList] = useState<any>([]);
  const { t } = useTranslation("Shed");
  const { user } = useAuth();
  const classes = useStyles();
  const refFieldShed = useRef<HTMLElement>(null);
  const refFieldMovementType = useRef<HTMLElement>(null);

  useEffect(() => {
    var parameters: ShedSearch = {
      pageSize: 1000,
      plantId: Number(user.company.plantID),
      responsibleUser: userName ? userName : '',
      ShedType: shedType,
    }

    ShedApi.search(parameters).then(response => {
      if (response && response.items) {
        let sheds = response.items.map((item: any) => (
          { 
            code: item.id.toString(), 
            label: item.code + ' - ' + (item.type === "D" ? t('unload') : t('load')), 
            shedCode: item.code, 
            shedType: item.type,
            movementTypes: item.movementTypes
          }));

          setShedList(sheds)
      }
    })

  }, [])

  const onChangeSelectShed = async (data: any) => {
    if(data === null) {
        setValue("movementType", {})
        return
    }

    setValue("movementType", {})
    setValue("shedMovementType", {})

    setMovementTypeList(data.movementTypes.map((item: any) => ({ 
      code: item.movementType.id, 
      label: item.movementType.description,
      tolerance: item.tolerance
    })))
   
    if (data.movementTypes.length === 1) {
      
      var movementTypeTemp = { code: data.movementTypes[0].movementType.id, label: data.movementTypes[0].movementType.description, tolerance: data.movementTypes[0].tolerance }

      if (onChangeMovementType != null)
        onChangeMovementType(movementTypeTemp)

      setValue("shedMovementType", movementTypeTemp)
      
      if(focusOnSelect) {
        focusOnSelect.current?.focus()
        focusOnSelect.current?.select()
      }
    }
    else {
        refFieldMovementType.current?.focus()
    }
  }

  return (
    <>
      {!title || title === '' ? <></> :
      <Grid container spacing={1}>
        <Typography className={classes.root}>
          {title}
        </Typography>
      </Grid>
      }
      <Grid item xs={2}>
          <Select 
              style={{width: '100%'}}
              label={t('shed')} 
              name={nameSelectShed}
              onChange={onChangeSelectShed}
              control={control} 
              allowSelectValueNotFound={false}
              inputRef={inputRef || refFieldShed}
              options={shedList}/>
      </Grid>

      <Grid item xs={3}>
          <Select 
              style={{width: '100%'}}
              label={t('movementType')} 
              name={nameSelectMovementType}
              control={control} 
              allowSelectValueNotFound={false}
              options= {movementTypeList}
              inputRef={refFieldMovementType}
              onChange={onChangeMovementType} />
      </Grid> 

      {showConfirmButton != true ? <></> :
      <Grid item xs={1}>
        <ButtonUI
            onClick={() => {onButtonClick(); refFieldShed.current?.focus()}}
            color="primary"
            variant="contained"
            style={{ maxWidth: '40px', maxHeight: '38px', minWidth: '40px', minHeight: '38px', marginTop: '20px' }}>
            <AddIcon />
        </ButtonUI>
      </Grid>}
    </>
  )
}

export default SelectShedMovementType
